import { ProductResult } from '../types/product';

// Cloudflare Pages에서는 같은 도메인의 /api/search로 호출
// 로컬 개발 시에는 REACT_APP_API_URL 환경변수로 백엔드 주소 지정
const API_BASE_URL = process.env.REACT_APP_API_URL || '';

interface SearchResponse {
  data: {
    total: number;
    products: ProductResult[];
    suggestedQuery: string | null;
  } | null;
  error: string | null;
  message: string;
}

/**
 * 백엔드 검색 API를 호출하여 필터링된 최저가 상품 목록을 가져온다.
 */
export async function searchProducts(
  query: string,
  sort: string = 'sim'
): Promise<SearchResponse> {
  const params = new URLSearchParams({ query, sort, display: '100' });
  const url = `${API_BASE_URL}/api/search?${params.toString()}`;

  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`검색 요청 실패 (${response.status})`);
  }

  return response.json() as Promise<SearchResponse>;
}
